import React from 'react'

export const JobListGrouping = () => {
  return <div>JobListGrouping</div>
}
